import React, { useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, MenuItem } from '@mui/material';
import Grid from '@mui/system/Unstable_Grid';
import * as yup from 'yup';
import { useFormik } from 'formik';
const DialogCancelInteracao = ({ initial, motivos, onClose, ...props }) => {
    const form = useFormik({
        initialValues: {},
        validationSchema: yup.object({
            motivoId: yup.number().required('O campo é obrigatório')
        }),
        validateOnMount: false,
        onSubmit: async (values) => {
            onClose(values.motivoId);
        }
    });
    useEffect(() => {
        form.resetForm();
        form.setValues(initial);
    }, [initial]);
    return (<Dialog {...props}>
      <form>
        <DialogTitle>Cancelar interação</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={12} md={12} xs={12}>
              <TextField label='Motivo de cancelamento' name='motivoId' value={form.values?.motivoId} onChange={form.handleChange} onBlur={form.handleBlur} fullWidth error={form.touched.motivoId && Boolean(form.errors.motivoId)} helperText={form.touched.motivoId && form.errors.motivoId} select>
                <MenuItem value={undefined} disabled></MenuItem>
                {motivos &&
            motivos.map(x => (<MenuItem value={x.id} key={x.id}>
                      {x.designacao}
                    </MenuItem>))}
              </TextField>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type='button' onClick={() => onClose(undefined)}>
            Cancelar
          </Button>
          <Button onClick={() => {
            form.handleSubmit();
        }} disabled={!form.isValid || !form.dirty || form.isSubmitting} variant='contained'>
            OK
          </Button>
        </DialogActions>
      </form>
    </Dialog>);
};
export default DialogCancelInteracao;
